export enum FormBody {
    property = 'Property',
    enum = 'Enum'
}
